"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Ul = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  list-style: disc outside url('https://buoyhealth.imgix.net/symptoms-a-z/bullet-dot.svg'); \n"], ["\n  ", ";\n  ", ";\n  list-style: disc outside url('https://buoyhealth.imgix.net/symptoms-a-z/bullet-dot.svg'); \n"]),
    _templateObject2 = _taggedTemplateLiteral(["margin: ", ";"], ["margin: ", ";"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyTheme = require("buoy-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Ul = exports.Ul = _styledComponents2.default.ul.withConfig({
  displayName: "Ul",
  componentId: "sc-1km20no-0"
})(_templateObject, function (props) {
  return props.margin ? (0, _styledComponents.css)(_templateObject2, props.margin) : "";
}, function (props) {
  return props.padding ? "padding: " + props.padding + ";" : (0, _buoyTheme.responsive)("padding", "0 0 0 40px", "0 0 0 40px", "0 0 0 32px", "0 0 0 32px", "0 0 0 32px");
});

Ul.defaultProps = {
  margin: "8px 0 32px 0"
};

exports.default = Ul;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-list/dist/components/Ul.js
// module id = 148
// module chunks = 168707334958949